module.exports = __webpack_public_path__ + "img/arrow-left-button.3a2fcab7.svg";